import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomButtons from '../../components/Elements/Buttons/customButton';
import CustomTittle from '../../components/Elements/customTittle/customTittle';
import Header from '../../components/Elements/header/header';
import EDSFooter from '../../components/EDSFooter';
import './InProgress.css';

const InProgress = (props) => {
    return (
        <>
            <Header>/ PROCES ZAKUPU KURSU</Header>
            <div className="InProgress">
                <CustomTittle>Status:</CustomTittle>
                <div className="tittle_stage">
                    <span className="tittle_content">W TRAKCIE REALIZACJI</span>
                </div>
                <div className="inProgress_details">
                    <CustomTittle>Zapisałeś się na kurs:</CustomTittle>

                    <div className="dataSummary_details">
                        <label className="dataSummary_details_row">
                            <p>Kurs:</p> <CustomTittle>PRO-M3</CustomTittle>
                        </label>
                        <label className="dataSummary_details_row">
                            <p>Poziom:</p> <CustomTittle>I - wprowadzający</CustomTittle>
                        </label>
                        <label className="dataSummary_details_row">
                            <p>Styl taneczny:</p> <CustomTittle>Taniec nowoczesny</CustomTittle>
                        </label>
                        <label className="dataSummary_details_row">
                            <p>instruktor:</p> <CustomTittle>Imię i nazwisko</CustomTittle>
                        </label>
                        <label className="dataSummary_details_row">
                            <p>Częstotliwość zajęć :</p>{' '}
                            <CustomTittle>1 raz w tygodniu</CustomTittle>
                        </label>
                        <label className="dataSummary_details_row">
                            <p>Dzień i godzina:</p> <CustomTittle>sobota 13:45-15:15</CustomTittle>
                        </label>
                    </div>

                    <div className="inProgress_end">
                        <p>DO ZOBACZENIA NA NAJBLIŻSZYCH ZAJĘCIACH!</p>
                        <div className="inProgress_endButton">
                            <CustomButtons classButton="solid" size="big">
                                ZOBACZ POZOSTAŁE KURSY
                            </CustomButtons>
                            <CustomButtons classButton="outline" size="big">
                                WRÓĆ DO STRONY GŁÓWNEJ
                            </CustomButtons>
                        </div>
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};

export default InProgress;
